import { useQuery } from '@tanstack/react-query';

import { GET_TEAM_UPGRADE_INTENT, type TeamUpgradeIntentResponse } from '../../contracts';
import { getTeamUpgradeIntent } from '../api/billing';
import {
  retryTeamUpgradeQuery,
  teamUpgradeErrorStatus,
} from './team-upgrade-intent-errors';

/** The workspace's team upgrade, or `null` when no member has been added yet. Admins only. */
export function useQueryTeamUpgradeIntent({
  enabled = true,
}: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [GET_TEAM_UPGRADE_INTENT],
    queryFn: async (): Promise<TeamUpgradeIntentResponse | null> => {
      try {
        const { data } = await getTeamUpgradeIntent();
        return data;
      } catch (error: unknown) {
        if (teamUpgradeErrorStatus(error) === 404) return null;
        throw error;
      }
    },
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: retryTeamUpgradeQuery,
  });
}
